import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  chatContainer: {
    flex: 1,
    height: `calc(100% - 48px)`,
    overflowY: 'hidden',
    padding: '4px 4px 0 4px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_100.main,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      height: '100%',
      marginTop: '0'
    }
  },

  chatPapper: {
    marginRight: '64px',
    display: 'flex',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      height: '100%'
    }
  },

  contactsWrapper: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    overflowY: 'hidden',
    [theme.breakpoints.down('lg')]: {
      paddingRight: '4px'
    },
    [theme.breakpoints.up('lg')]: {
      paddingRight: '4px'
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      height: '100%'
    }
  },
  messagesWrapper: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      width: '100%',
      backgroundColor: theme.palette.background.paper
    }
  },
  welcomeMsg: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'space-evenly',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    height: '100%',
    // textAlign: 'center',
    borderRadius: '8px',
    border: 'none',
    '& span': {
      color: theme.palette.gray_400.main,
      fontWeight: '500'
    },
    '& svg': {
      color: theme.palette.blue_300.main
    }
  }
}))
